module.exports = __webpack_public_path__ + "img/solution2.69e22276.png";